/*
 *
 * AbsenceMobile constants
 *
 */

// LOAD
export const LOAD_ABSENCES = 'app/AbsenceMobile/LOAD_ABSENCES';
export const LOAD_ABSENCES_SUCCESS =
  'app/AbsenceMobile/LOAD_ABSENCES_SUCCESS';
export const LOAD_ABSENCES_ERROR =
  'app/AbsenceMobile/LOAD_ABSENCES_ERROR';

// CHANGE/UPDATE
export const CHANGE_ABSENCE = 'app/AbsenceMobile/CHANGE_ABSENCE';
export const CHANGE_ABSENCE_SUCCESS =
  'app/AbsenceMobile/CHANGE_ABSENCE_SUCCESS';
export const CHANGE_ABSENCE_ERROR =
  'app/AbsenceMobile/CHANGE_ABSENCE_ERROR';

// DELETE
export const DELETE_ABSENCE = 'app/AbsenceMobile/DELETE_ABSENCE';
export const DELETE_ABSENCE_SUCCESS =
  'app/AbsenceMobile/DELETE_ABSENCE_SUCCESS';
export const DELETE_ABSENCE_ERROR =
  'app/AbsenceMobile/DELETE_ABSENCE_ERROR';

export const FLUSH_STATE_ABSENCEMOBILE =
  'app/AbsenceMobile/FLUSH_STATE_ABSENCEMOBILE';
